// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weight-chart-container {
  width: 90%;
  max-width: 600px;
  height: 300px;
  margin: 30px auto;
  background-color: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

@media (max-width: 600px) {
  .weight-chart-container {
    width: 95%;
    height: 250px;
    padding: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/WeightChart.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,aAAa;EACf;AACF","sourcesContent":[".weight-chart-container {\n  width: 90%;\n  max-width: 600px;\n  height: 300px;\n  margin: 30px auto;\n  background-color: white;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 600px) {\n  .weight-chart-container {\n    width: 95%;\n    height: 250px;\n    padding: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
